// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__35RSK","vLegacy":"SelectSecondary_vLegacy__I1pVg","error":"SelectSecondary_error__k4LMl","disabled":"SelectSecondary_disabled__2Z8Q2"};